<template>
  <div>
    <div class="footer-main">
      <div class="footer-main-content">
        <div class="menu-root">
          <p class="menu-item"><router-link to="/home">Home</router-link></p>
        </div>
        <div class="menu-root" v-for="menu in menus" :key="menu.id">
          <p v-if="menu.link === undefined" class="menu-item">
            {{ menu.title }}
          </p>
          <router-link v-else :to="{ path: menu.link }">{{
            menu.title
          }}</router-link>
          <ul class="menu-item">
            <li
              v-for="subMenu in menu.subMenus"
              :key="subMenu.id"
              class="menu-item"
            >
              <p class="menu-item">
                <router-link :to="{ path: subMenu.link }">{{
                  subMenu.title
                }}</router-link>
              </p>
            </li>
          </ul>
        </div>
        <div class="menu-root" v-for="website in websites" :key="website.id">
          <p v-if="website.link === undefined" class="menu-item">
            {{ website.title }}
          </p>
          <p v-else class="menu-item">
            <router-link :to="{ path: website.link }">{{
              website.title
            }}</router-link>
          </p>
          <ul class="menu-item">
            <li v-for="subMenu in website.subMenus" :key="subMenu.id">
              <p class="menu-item">
                <a :href="subMenu.link" target="_blank">
                  {{ subMenu.title }}
                </a>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-lower-content">
      <p>© 2022 {{ nameSite }}. All rights reserved.</p>
      <p>Made by Lanulledu28 {{ version }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterBar",
  components: {},
  props: ["menus"],
  data() {
    return {
      version: process.env.VUE_APP_VERSION_APP,
      nameSite: "BeLeafInTrees",
      websites: [
        {
          id: 0,
          title: "Links to helpfull websites",
          subMenus: [
            {
              id: 0,
              title: "www.nzpcn.org.nz",
              link: "https://www.nzpcn.org.nz/",
            },
            {
              id: 1,
              title: "www.tourleader.nz",
              link: "https://www.tourleader.nz/new-zealand-travel-information/plants-new-zealand",
            },
            {
              id: 2,
              title: "www.doc.govt.nz",
              link: "https://www.doc.govt.nz/",
            },
          ],
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.footer-main {
  display: flex;
  padding: 0.5rem;
  justify-content: center;
}
.footer-main-content {
  display: flex;
  gap: 15px;
  flex-direction: column;
  @media (min-width: $constraint-width-small) {
    flex-direction: row;
  }
}
.menu-root {
  text-align: center;
}
.menu-item {
  margin: 0;
  line-height: 1.15rem;
}
a:hover {
  color: $color-primary;
}
.footer-lower-content {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
